<template>
  <input
    class="form-input"
    :type="inputType"
    :placeholder="placeholder"
    :value="value"
    :maxlength="maxlength"
    @input="handlerInput"
    @keyup="handlerKeyup"
  />
</template>

<script>
export default {
  name: 'FormInput',
  props: {
    // eslint-disable-next-line vue/require-default-prop
    value: [String, Number],
    placeholder: {
      type: String,
      require: false,
      default: '请输入'
    },
    type: {
      type: String,
      require: false,
      default: 'text'
    },
    maxlength: {
      type: [String, Number],
      require: false,
      default: ''
    },
    validate: {
      type: Function,
      require: false,
      default: null
    }
  },
  computed: {
    inputType() {
      if (this.type === 'number') {
        return 'tel'
      }
      return 'text'
    }
  },
  methods: {
    handlerInput(e) {
      const { value } = e.target
      if (this.validate) {
        const res = this.validate(value)
        if (res !== true) {
          if (res === false) {
            e.target.value = this.value
          } else {
            e.target.value = res
          }
          return false
        }
      }
      this.$emit('input', value)
    },
    handlerKeyup(e) {
      if (this.maxlength && this.value.length === parseInt(this.maxlength)) {
        this.$toast(`最多输入${this.maxlength}个字`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.form-input {
  display: block;

  padding: 0;

  outline: none;

  flex: auto;

  font-size: 0.34rem;
  line-height: 0.44rem;
  color: #333;
}
</style>
